import { lazy, Suspense } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/Button";
import { Container } from "@/components/ui/Container";
import { fadeInUp, fadeIn } from "@/lib/motion";
import { useLanguage } from "@/components/LanguageContext";


export function HeroSection() {
  const { t } = useLanguage();

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-charcoal">
      {/* Background Image from PDF extraction */}
      <div 
        className="absolute inset-0 z-0 opacity-40 mix-blend-luminosity"
        style={{
          backgroundImage: "url('/images/hero-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      {/* Subtle overlay gradient to ensure text readability */}
      <div className="absolute inset-0 z-0 bg-gradient-to-r from-charcoal via-charcoal/80 to-transparent" />

      {/* Content */}
      <Container className="relative z-10 py-32 lg:py-40">
        <div className="max-w-3xl">

          
          <motion.div
            variants={fadeIn}
            initial="hidden"
            animate="visible"
            className="mb-6"
          >
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-warm-white/60 backdrop-blur-sm border border-amber/20 text-xs font-medium tracking-wider uppercase text-amber-dark">
              <span className="w-1.5 h-1.5 rounded-full bg-amber animate-pulse" />
              Solutions Group
            </span>
          </motion.div>

          <motion.h1
            variants={fadeInUp}
            initial="hidden"
            animate="visible"
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-sans font-bold text-warm-white leading-[1.08] tracking-tight"
          >
            {t("Quand la Mobilité", "When Mobility")}
            <br />
            {t("Rencontre l'Avenir", "Meets Future")}<span className="text-amber">.</span>
          </motion.h1>

          <motion.p
            variants={fadeInUp}
            initial="hidden"
            animate="visible"
            transition={{ delay: 0.15 }}
            className="mt-6 text-lg md:text-xl text-warm-white/80 leading-relaxed max-w-xl"
            dangerouslySetInnerHTML={{
              __html: t(
                "Des solutions <span class='text-amber font-semibold'>expertes</span> et innovantes pour penser, modéliser et <span class='text-amber font-semibold'>piloter les mobilités</span> de demain.",
                "Expert and innovative solutions to design, model, and <span class='text-amber font-semibold'>steer the mobility</span> of tomorrow."
              )
            }}
          />

          <motion.div
            variants={fadeInUp}
            initial="hidden"
            animate="visible"
            transition={{ delay: 0.3 }}
            className="mt-10 flex flex-wrap gap-4"
          >
            <Button href="/services" variant="primary" size="lg">
              {t("Nos Services", "Explore Services")}
            </Button>
            <Button href="/contact" variant="secondary" size="lg">
              {t("Demander un Devis", "Request a Quote")}
            </Button>
          </motion.div>
        </div>
      </Container>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-warm-white to-transparent" />
    </section>
  );
}
